import businessHowImage from 'public/images/header/menu-content-photo3.png'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { HeaderNavigationBusiness } from '@/src/domains/header/components/Header/HeaderNavigationBusiness'

export const HeaderNavigationBusinessHow = () => {
  const { t } = getTranslate()

  return (
    <HeaderNavigationBusiness
      slug="business-how-it-works-menu"
      title={t('component.navigation.howItHelpsYourCompany')}
      image={businessHowImage}
    />
  )
}
